module.exports = __webpack_public_path__ + "img/video_p.367e2dbd.svg";